export default {
    header: {
        products: '产品介绍',
        vg: '视频导航',
        download: '下载',
        about: '关于我们'
    },
    pageTitle1: '让电视变得更',
    pageTitle2: '智能',
    available: '未开售',
    buy: '购买',
    config: '配置',
    os: {
        title: '玩法更多样, 体验再升级',
        intro: 'AuroraTV生态，旗下 AuroraOS 基于 Slimbox 匠心开发，版本实现系统网络深度优化、运行速度全面提速，以轻量化架构打造流畅交互体验！'
    },
    comment: {
        title: '用户真实评价',
        Subtitle: '听听他们怎么说',
        text: '已购用户分享的真实使用感受，助你放心选择。'
    },
    certificate: {
        title: '选择 AURORA',
        text: '重新定义你的电视体验 — AURORA 智能系统'
    },
    aurora: {
        title: 'AURORA 应用生态圈',
        mcplayer: 'MCPlayer 是一款提供业界领先的体育直播、电影和电视订阅服务的流媒体播放器，支持实时赛事、海量影视点播及电视频道流媒体播放, MCPlayer 频道和内容可能会因国家或地区而异。',
        mcstore: 'McStore应用商店是专为Andriod TV打造的智能电视应用平台，提供海量正版应用、游戏及影视服务!'
    },
    osIntro: 'AURORATV os相对于市场其他固件又有哪些新的功能?',
    osTitle: '更多的',
    osSecTitle: '扩展功能',
    extended: {
        remote: '自定义快捷键',
        timezone: '一键修复网络',
        clean: '一键式内存清理',
        intro1: '用户自定义遥控器的按键功能，适配多种遥控器设备，并配合AURORA最新系统，一个按键即可实现快速打开应用程序',
        intro2: '网络限制或NTP服务器故障导致无法正常上网时，可一键切换NTP服务器，快速恢复网络时间同步',
        intro3: '只需轻点，即可轻松清理电视缓存，从而提高电视运行速度, 使操作更流畅, 保持电视最佳性能'
    },
    equipped: {
        title: '搭载机型',
        buy: '购买',
        productParame: '产品参数',
        tanix: {
            param1: 'CPU: Amlogic S905W2',
            param2: '存储: 4+32GB/4+64GB',
            param3: '操作系统: Andriod 11.0'
        },
        x96q: {
            param1: 'CPU: Allwinner H313',
            param2: '存储: 2+16GB',
            param3: '操作系统: Andriod 10.0'
        },
        aurora: {
            param1: 'CPU: Amlogic S905W2',
            param2: '存储: 4+32GB/4+64GB',
            param3: '操作系统: Andriod 11.0'
        },
        elite: {
            param1: 'CPU: Quad Core ARM Cortex A53',
            param2: '存储: 2+16GB',
            param3: '操作系统: Andriod 10.0'
        }
    },
    remote: {
        intro: '手机遥控电视，随时随地，尽在掌握，让生活更轻松自然!',
        download: '立即下载',
        note: '应用当前仅支持',
        andriod: '安卓手机',
        open_intro: '手机便捷操控电视应用，一键秒开常用软件。支持自定义排序，高频应用置顶，操作流畅直观。',
        ipt_intro: '在电视上输入的文字现在可以不需要连续点击屏幕，而只需在应用程序中输入并发送到电视上。',
        file_intro: '您可以通过上传APK功能,将Andriod APK上传到电视上,从而实现应用安装, 相对于通过U盘安装更加方便快捷!',
        ctl_intro: 'Aurora Remote 应用程序允许您控制您的 Android 智能电视，而不是使用物理遥控器。',
        fbTitle: '拿起手机',
        fbSecTitle: '打开应用随时操作',
        fbIntro: '不分机型，打开应用连接设备，随时操作遥控',
        more: '更多功能'
    },
    application: {
        title: '专属应用程序，赛事资讯尽在掌握',
        mcstore: {
            appName: 'MCStore',
            appDesc: '提供上百款安全可靠的电视应用，轻松快速下载安装，即装即用。'
        },
        mcplayer: {
            appName: 'MCPlayer',
            appDesc: '订阅即可观看20,000个电视频道、100,000部影视剧集，其中包含3,000个体育频道。'
        }
    },
    userComment: [{
            content: '这是第二次购买这个机顶盒了，运行正常，联网快速简单，目前一切满意，没有意见！'
        },
        {
            content: '太棒了！开箱即用！既有电视频道又有电影！运行流畅无卡顿无故障'
        },
        {
            content: '质量优秀，一切运行正常。非常喜欢，应用程序安装毫无问题'
        },
        {
            content: '出色的机顶盒，比我之前用的好多了，画质优秀，运行流畅。设置起来也没有问题'
        },
        {
            content: '对购买很满意，客户也是。需要什么就安装什么，我指的是固件。总之大家都很满意，我也没亏'
        },
        {
            content: '我知道我在买什么 - 这是目前性价比最好的电视盒子！可以放心推荐购买！'
        }
    ],
    feature: {
        specification: '规范',
        product: '产品',
        x96q: {
            f: "性能核心，瞬时响应",
            s: "全设备兼容"
        },
        aurora: {
            f: "四核A35架构",
            s: "双频Wi-Fi 5"
        },
        tanix: {
            f: "Slimbox+定制固件",
            s: "静音散热系统"
        }
    },
    videoGuidece: '操作问题和解答',
    videoTitle: '教学视频',
    videoIntroduction1: 'Tanix W2刷机视频',
    videoIntroduction2: 'MCPlayer 应用程序教学视频',
    videoIntroduction3: '蓝牙遥控器配对教程',
    dowmloadRemote: {
        mainDesc: '兼容所有搭载SlimBOX+系统的Aurora机顶盒,使用Aurora Remote应用，轻松通过智能手机掌控您的电视！只需确保智能电视与Aurora Remote处于同一WiFi网络下，或通过蓝牙配对连接, 即可轻松实现开启/关闭电视、一键打开应用程序、音量调节、应用安装!',
        dowmload: '下载应用程序',
        text1: '目前仅支持',
        text2: '安卓手机',
        text3: '版本',
        title: 'AURORA电视遥控器',
        'secondary_title': '轻松控制你的电视，解锁更多智能体验',
        'quick_title': '快速启动',
        'quick_title_sec': '应用程序',
        'quick_open_txt': '系统自动扫描电视已安装的所有应用程序，同时支持用户个性化自定义应用排序。通过简单的拖拽操作，您可以将最喜爱的应用程序置顶，打造专属快捷启动入口，一键打开应用',
        'file_title': '文件',
        'file_secondary_title': '传输',
        'file_txt': '无需U盘, 即可通过Aurora Remote文件上传功能, 将APK上传至机顶盒, 实现应用安装!',
        'media_title': '响应式',
        'media_secondary_title': '触控板',
        'media_txt': '使用方向键或滑动板导航,就像使用真实的物理遥控器, 轻松控制电视!',
        'search_title': '快速',
        'search_secondary_title': '文本输入和搜索',
        'search_txt': '支持快捷文本输入和搜索，让电视操作更高效。'
    },
    dowmloadMcstore: {
        mainDesc: 'AURORA旗下自有的应用市场平台，我们提供超过百款可靠且安全的电视应用程序，方便您轻松快速地下载和使用。',
        dowmload: '下载应用程序',
        text1: '此应用仅适用于',
        text2: 'Andriod TV'
    },
    about: {
        headHL: '你好!',
        headSub: '我们是AURORA',
        outTitle1: 'AURORA是什么?',
        outIntro1: 'AURORA 是一家 IT 公司，同时也是一家创意实验室，拥有先进的生产设备、活跃的社群、充满活力的创造活力以及让每个人都能感受到自身价值的文化。自 2024 年以来，我们一直致力于为人们创造技术、智能设备和便捷的服务。品质保证',
        outTitle2: '品质保证',
        outIntro2: '所有工作均以研究为起点。在此基础上，我们完成多维度概念推演、原型迭代、硬件架构搭建及设计方案论证。过程中，我们整合行业权威专家资源，建立与科研机构的协同合作机制，并依托先进专业设备开展系统性实验与测试验证。在设备、服务及技术的全开发周期内，未来用户需求始终作为核心导向贯穿始终。',
        outTitle3: '服务保障',
        outIntro3: '所有 AURORA机顶盒均为正品，从研发、生产到销售，全程遵循严格的质量管控体系，每一台产品都经过多道质量检测工序，确保消费者购买到的每一台机顶盒都品质卓越、性能稳定，为您带来可靠、优质的使用体验 。',
        outTitle4: '投资者',
        outIntro4Part1: '如需咨询投资者相关事宜，请发送邮件至',
        outIntro4Part2: '或添加Telegram/WhatsApp联系。',
        outTitle5: '个人客户',
        outIntro5Part1: '如有一般问题，包括个人及批量订单、价格、物流、支付、配送和退货政策等问题，请联系移步联系。',
        outIntro5Part2: 'OZON官方门店',
        outIntro5Part3: '联系。',
        contactHL: '商务合作联系',
        contactSub: 'Contact'
    },
    footer: {
        serverTitle: '咨询时间:',
        serverTime: '周一至周五9:00－11:30,14:00－17:30，法定节假日除外'
    }
}